import { render, staticRenderFns } from "./MedtoolRequest.vue?vue&type=template&id=bc045128&scoped=true"
import script from "./MedtoolRequest.vue?vue&type=script&lang=js"
export * from "./MedtoolRequest.vue?vue&type=script&lang=js"
import style0 from "./MedtoolRequest.vue?vue&type=style&index=0&id=bc045128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc045128",
  null
  
)

export default component.exports